// Reference: https://www.npmjs.com/package/tai-password-strength
export enum PASSWORD_STRENGTH {
    veryWeak = 'VERY_WEAK',
    weak = 'WEAK',
    reasonable = 'REASONABLE',
    strong = 'STRONG',
    veryStrong = 'VERY_STRONG',
}
